module.exports = __webpack_public_path__ + "static/media/bem.02dbf810.png";